import type { IMessage } from '../types/network';

import f1 from '@eab-pip/pi-f1';

/**
 * store messages for the bot interface
 */
export class MessagesModel {
  /**
   * receive the list of messages from the KnowledgeBot
   */
  constructor(private messages: IMessage[]) {}

  async startup() {
    return this;
  }

  async shutdown() {
    return this.eraseAll();
  }

  /**
   * remove all messages
   */
  eraseAll() {
    this.messages.length = 0;
    return this;
  }

  /**
   * @returns true if there are more than one message
   */
  hasAny() {
    return this.messages.length > 0;
  }

  /**
   * @returns all messages
   */
  readAll() {
    return this.messages;
  }

  /**
   * @returns '' (or) the message associated with the token
   */
  findMessage(messageIndex: number) {
    return f1.read(`/${messageIndex}/feedback`, '', this.messages);
  }
}
